const Index = () => {
  return <p className="text-hd1">404 Page not found!</p>;
};

export default Index;
